import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=7cdce8cd&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=ts&"
export * from "./Inventory.vue?vue&type=script&lang=ts&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=7cdce8cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdce8cd",
  null
  
)

export default component.exports